import Box from "@mui/material/Box";
import Header from "../main-layout/header/Header";
import Sidebar from "../main-layout/sidebar/Sidebar";
import { Outlet, useLocation } from "react-router-dom";
import { AppBar, CssBaseline } from "@mui/material";
import { useState, useEffect, useRef } from "react";
import Addproject from "../common/Addproject";
import Addexperience from "../common/Addexperience";
import Mapmodal from "../common/Mapmodal";
import OnboardingWizard from "../create-account/OnboardingWizard";
import ReportModal from "../common/ReportModal";
import ChooseLocation from "../common/Chooselocation";
import {
  setChatCount,
  setSelectedsite,
  setShowaddexperience,
  setShowaddproject
} from "../../redux/actions/actions";
import { useDispatch } from "react-redux";
import { useTheme } from "@mui/material/styles";
import { useSelector } from "react-redux";
import { ReportSuccess } from "../common/ReportSuccess";
import { BuildIdEventListener } from "../../common/BuildIdEvent";
import {
  db,
  deleteChatandMessagesFromIndexedDB,
  getChatByIdFromIndexedDB,
  getChatsFromIndexedDB,
  saveChatsToIndexedDB,
  updateChatInIndexedDB
} from "../../db";
import { setChatGroups, setSelectedChat } from "../../redux/actions/actions";
import {
  getCurrentChatgroup,
  getFormattedDate,
  getLastMessage,
  getPreviewMediaType
} from "../../common/Helper";
import { LEAVE_CHAT_GROUP } from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";

const TAG = "Chat";

function Mainlayout({ loading }) {
  const location = useLocation();
  const dispatch = useDispatch();
  const [contentPadding, setContentpadding] = useState(null);
  const [splashScreen, setSplashScreen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [desktopSidebarOpen, setDesktopSidebarOpen] = useState(true);
  const [isOnboarding, setIsOnboarding] = useState(false);
  let getPath = location?.pathname.split("/").pop();
  const theme = useTheme();

  useEffect(() => {
    if (localStorage.getItem("onboardingPending") === "true") {
      setIsOnboarding(true);
    }
  }, []);

  const { showMapmodal, loginData, selectedChat, chatGroups, unreadMsgCount } = useSelector(
    (state) => state?.main
  );

  const drawerWidth = 210;

  const unreadMsgCountRef = useRef(0);
  const selectedChatRef = useRef({});
  const chatGroupsRef = useRef([]);

  useEffect(() => {
    unreadMsgCountRef.current = unreadMsgCount;
  }, [unreadMsgCount]);

  useEffect(() => {
    chatGroupsRef.current = chatGroups;
  }, [chatGroups]);

  useEffect(() => {
    selectedChatRef.current = selectedChat;
  }, [selectedChat]);

  useEffect(() => {
    setContentpadding(location?.pathname.split("/").pop());
    clearMap();
  }, [location?.pathname]);

  const clearMap = () => {
    if (getPath === "sites") {
      dispatch(setShowaddproject(null));
      dispatch(setShowaddexperience(false));
      dispatch(setSelectedsite(null));
    }
  };

  useEffect(() => {
    // Only set up event listeners when we're on the chat route
    const setListener = () => {
      BuildIdEventListener.onNewChatMessage(async (newMsg) => {
        // Check if this is a delete message
        // if (newMsg[0]?.messageText === "a3f38d6a-c85e-49a9-a9d5-6f9de8c8559d") {
        //   const chatToDelete = await getChatByIdFromIndexedDB(Number(newMsg[0]?.toChatGroupId));
        //   // Only delete if it's a non-group chat with exactly 2 users
        //   if (chatToDelete && !chatToDelete.isGroupchat && chatToDelete?.nrOfUsersInGroup === 2) {
        //     await handleLeaveChatGroup(Number(newMsg[0]?.toChatGroupId));
        //   }
        //   return;
        // }
        if (newMsg && newMsg?.length > 0) {
          if (selectedChatRef.current?.chatGroupId !== Number(newMsg[0]?.toChatGroupId)) {
            if (Number(newMsg[0]?.fromUserId) !== Number(loginData?.userInformation?.UserId)) {
              const currentCount = unreadMsgCountRef?.current || 0;
              dispatch(setChatCount(currentCount + 1));
            }
            mergeMessageInChatGroup(newMsg); // It's for increase the unread chat count and last messages in user list
          } else {
            updateLastmessage(newMsg); // It's use for update the last message in user list
          }
        }
      }, TAG);
      BuildIdEventListener.onChatCountChange((data) => {
        if (data?.UnreadMessageCount !== undefined) {
          dispatch(setChatCount(data.UnreadMessageCount));
        }
      }, TAG);
      BuildIdEventListener.ReportedChatGroup(async (data) => {
        const chatGroupId = Number(data?.[0]?.chatGroupId);
        if (chatGroupId) {
          const cachedChats = await getChatsFromIndexedDB();
          const chatToRemove = cachedChats.find((chat) => chat.chatGroupId === chatGroupId);
          if (chatToRemove?.unreadMessagesNr > 0) {
            const currentUnread = unreadMsgCountRef?.current || 0;
            dispatch(setChatCount(Math.max(0, currentUnread - chatToRemove?.unreadMessagesNr)));
          }
          const updatedGroups = cachedChats.filter((chat) => chat.chatGroupId !== chatGroupId);
          dispatch(setChatGroups([...updatedGroups]));
          if (selectedChatRef.current?.chatGroupId === chatGroupId) {
            dispatch(setSelectedChat({}));
          }
          // CASCADE DELETE: Remove chat and all its messages from IndexedDB
          await deleteChatandMessagesFromIndexedDB(chatGroupId).catch((err) =>
            console.error("Error deleting reported chat from DB:", err)
          );
        }
      }, TAG);
    };
    setListener();
    // Cleanup when leaving the chat route
  }, []);

  // When new message come we need to move the current user to top of the user list
  const mergeMessageInChatGroup = async (newMsg) => {
    const msg = newMsg[0];
    const cachedChats = await getChatsFromIndexedDB();
    const index = cachedChats.findIndex((item) => item.chatGroupId == msg?.toChatGroupId);
    if (index === -1) {
      // If chat group not found, we may need to fetch its details
      let getNewChatgroup = await getCurrentChatgroup(msg?.toChatGroupId, loginData);
      cachedChats.unshift({
        ...getNewChatgroup
      });
      await saveChatsToIndexedDB(cachedChats); // Store new chat in IndexedDB
      dispatch(setChatGroups([...cachedChats])); // Update state to reflect new chat group
    } else {
      const objectToEdit = cachedChats.at(index);

      cachedChats.splice(index, 1); // remove the element
      const updatedUnreadCount =
        objectToEdit?.unreadMessagesNr +
        (msg?.fromUserId !== loginData?.userInformation?.UserId ? 1 : 0);

      Object.assign(objectToEdit, {
        ...objectToEdit,
        dateSent: msg?.dateSent, // Keep original ISO date for sorting
        dateSentDisplay: getFormattedDate(msg?.dateSent), // Formatted for display
        messageLanguage: msg?.messageLanguage,
        messageText: msg?.messageTypeId === 6 ? msg?.messageText : getLastMessage(msg, loginData),
        previewMediaType: getPreviewMediaType(msg),
        unreadMessagesNr: updatedUnreadCount
      });
      cachedChats.unshift(objectToEdit); // Add the edited object to the beginning of the array recent chat user we can see on top
      dispatch(setChatGroups([...cachedChats]));
      // ✅ UPDATE INDEXEDDB: Update chat with new message details
      await updateChatInIndexedDB(msg?.toChatGroupId, {
        messageText: msg?.messageTypeId === 6 ? msg?.messageText : getLastMessage(msg, loginData),
        messageTypeId: msg?.messageTypeId,
        previewMediaType: getPreviewMediaType(msg),
        dateSent: msg?.dateSent, // Keep original ISO date
        dateSentDisplay: getFormattedDate(msg?.dateSent), // Formatted for display
        lastMessageTime: new Date(msg?.dateSent).getTime(),
        messageLanguage: msg?.messageLanguage,
        unreadMessagesNr: updatedUnreadCount,
        fromUserId: msg?.fromUserId,
        fromUserFirstName: msg?.fromUserFirstName || objectToEdit.fromUserFirstName,
        fromUserLastName: msg?.fromUserLastName || objectToEdit.fromUserLastName
      });
    }
  };

  // Show the last message update the user list
  const updateLastmessage = async (newMsg) => {
    const msg = newMsg[0];
    if (selectedChatRef?.current?.chatGroupId === msg?.toChatGroupId) {
      const cachedChats = await getChatsFromIndexedDB();
      const index = cachedChats.findIndex((item) => item.chatGroupId === msg?.toChatGroupId);
      if (index !== -1) {
        const objectToEdit = cachedChats.at(index);
        cachedChats.splice(index, 1); // remove the element
        Object.assign(objectToEdit, {
          ...objectToEdit,
          dateSent: msg?.dateSent, // Keep original ISO date
          dateSentDisplay: getFormattedDate(msg?.dateSent), // Formatted for display
          messageLanguage: msg?.messageLanguage,
          messageText: msg?.messageTypeId === 6 ? msg?.messageText : getLastMessage(msg, loginData),
          previewMediaType: getPreviewMediaType(msg)
        });
        cachedChats.unshift(objectToEdit); // Add the edited object to the beginning of the array
        dispatch(setChatGroups([...cachedChats]));
        // ✅ UPDATE INDEXEDDB: Update chat with new message (no unread count change as user is in chat)
        await updateChatInIndexedDB(msg?.toChatGroupId, {
          messageText: msg?.messageTypeId === 6 ? msg?.messageText : getLastMessage(msg, loginData),
          messageTypeId: msg?.messageTypeId,
          previewMediaType: getPreviewMediaType(msg),
          dateSent: msg?.dateSent, // Keep original ISO date
          dateSentDisplay: getFormattedDate(msg?.dateSent), // Formatted for display
          lastMessageTime: new Date(msg?.dateSent).getTime(),
          messageLanguage: msg?.messageLanguage,
          fromUserId: msg?.fromUserId,
          fromUserFirstName: msg?.fromUserFirstName || objectToEdit.fromUserFirstName,
          fromUserLastName: msg?.fromUserLastName || objectToEdit.fromUserLastName
        });
      }
    }
  };

  const handleLeaveChatGroup = async (chatGroupId) => {
    try {
      const deletePayload = {
        UserId: loginData?.userInformation?.UserId,
        ChatGroupId: chatGroupId,
        ModifiedBy: loginData?.userInformation?.UserId
      };
      await Postrequestcall(LEAVE_CHAT_GROUP, deletePayload, loginData?.accessToken);
      // Find the chat to be deleted to check for unread messages
      const chatToDelete = chatGroupsRef.current.find((chat) => chat.chatGroupId === chatGroupId);
      // Decrease unread count if the deleted chat had unread messages
      if (chatToDelete?.unreadMessagesNr > 0) {
        const currentUnread = unreadMsgCountRef.current || 0;
        dispatch(setChatCount(Math.max(0, currentUnread - chatToDelete?.unreadMessagesNr)));
      }
      // Remove chat from the list
      const updatedGroups = chatGroupsRef.current.filter(
        (chat) => chat.chatGroupId !== chatGroupId
      );
      dispatch(setChatGroups([...updatedGroups]));
      // Clear selected chat if it was the one being deleted
      if (selectedChatRef?.current?.chatGroupId === chatGroupId) {
        dispatch(setSelectedChat({}));
      }
      // CASCADE DELETE: Remove chat and all its messages from IndexedDB
      await deleteChatandMessagesFromIndexedDB(chatGroupId);
    } catch (error) {
      console.error("Leave chat group error:", error);
    }
  };

  return (
    <>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        {/* Header */}
        <AppBar
          className="header-appbar"
          position="fixed"
          sx={{ zIndex: (theme) => theme?.zIndex?.drawer + 1 }}>
          <Header
            setSplashScreen={setSplashScreen}
            setMobileOpen={setMobileOpen}
            toggleDesktopSidebar={() => setDesktopSidebarOpen(!desktopSidebarOpen)}
            loading={loading}
          />
        </AppBar>
        {/* Sidebar */}
        <Sidebar setMobileOpen={setMobileOpen} mobileOpen={mobileOpen} desktopOpen={desktopSidebarOpen} />
        {/* Main Content with Sidebar Adjustment */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            height: `calc(100vh - ${theme?.mixins?.toolbar?.minHeight}px)`, // Dynamically set height
            overflowY: "auto",
            mt: `${theme?.mixins?.toolbar?.minHeight}px`, // Push content below AppBar
            width: { sm: desktopSidebarOpen ? `calc(100% - ${drawerWidth}px)` : "100%" }, // Ensure content doesn't go behind Sidebar
            ml: { sm: 0 },
            backgroundColor: "#f2f2f2",
            transition: "width 0.2s ease, margin-left 0.2s ease"
          }}>
          <Outlet context={{ handleLeaveChatGroup }} />
        </Box>
        <Addproject />
        <Addexperience />
        {showMapmodal?.open && <Mapmodal />}
        <ChooseLocation />
        <ReportModal />
        <ReportSuccess />
        {isOnboarding && (
          <OnboardingWizard
            open={isOnboarding}
            closeOnboarding={() => {
              localStorage.removeItem("onboardingPending");
              setIsOnboarding(false);
            }}
          />
        )}
      </Box>
    </>
  );
}

export default Mainlayout;
